import { Injectable } from "@angular/core";
import { API_URL, OperationType } from "common/constants/sm-constants";
import { FeedbackMappingModel } from "common/models/page-models/Feedback-Mapping/feedback-mapping-data-model";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { DataService } from "../../base-data-services/data.service";
import { environment } from "src/environments/environment";

@Injectable()
export class EditFeedbackTitleDataService extends DataService<FeedbackMappingModel> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.editFeedbackList,http);
    }
 
     override generateUrl(type: OperationType, paramKey?: any, extraKey?: any) {
        return environment.apiUrl + this.getAPI_URL();
      }
   
    createInstance(): FeedbackMappingModel {
        return new FeedbackMappingModel();
    }

    
 
}